import { createRoutine } from 'redux-saga-routines';
import extendRoutine from 'utils/routines';

import { GET_INDIVIDUAL_INSTANCES, EDIT_INDIVIDUAL_INSTANCE, CHECK_HEALTH } from './constants';

export const getIndividualInstances = extendRoutine(createRoutine(GET_INDIVIDUAL_INSTANCES), 'RESET');
export const editIndividualInstance = extendRoutine(createRoutine(EDIT_INDIVIDUAL_INSTANCE), 'RESET');
export const checkHealth = extendRoutine(createRoutine(CHECK_HEALTH), 'RESET');
